export const mockPromise = (value: any, timeout: number = 0) => {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout, value);
  });
};
